import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _theme => ({
    footerButtonsContainer: {
      display: "flex",
      gap: "8px",
      margin: "24px auto -18px",
      width: "fit-content"
    },
    proceedButton: {
      "& > span": {
        color: "#ffffff"
      },
      "&:hover": {
        backgroundColor: "#3c60fa"
      },
      backgroundColor: "#0030FF",
      padding: "6px 12px",
      minWidth: 120,
      width: "fit-content"
    },
    setLaterButton: {
      "& > span": {
        color: "#3d3d3d"
      },
      backgroundColor: "#F5F5F5",
      padding: "6px 18px",
      minWidth: 120,
      width: "fit-content"
    },
    subContent: {
      color: "#747C8C",
      fontSize: "14px",
      padding: "0 1em",
      textAlign: "center"
    }
  }),
  { name: "PromptDialog" }
);
